import { createGlobalStyle } from 'styled-components'

import { theme } from './theme'

const GlobalStyles = createGlobalStyle<{ mode: 'light' | 'dark' }>`
  @font-face {
    font-family: 'DINPro';
    src:
      url('../../assets/fonts/DINPro/DINPro-Light.woff2') format('woff2'),
      url('../../assets/fonts/DINPro/DINPro-Light.woff') format('woff');
    font-weight: 300;
    font-style: normal;
  }

  @font-face {
    font-family: 'DINPro';
    src:
      url('../../assets/fonts/DINPro/DINPro-Regular.woff2') format('woff2'),
      url('../../assets/fonts/DINPro/DINPro-Regular.woff') format('woff');
    font-weight: 400;
    font-style: normal;
  }

  @font-face {
    font-family: 'DINPro';
    src:
      url('../../assets/fonts/DINPro/DINPro-Medium.woff2') format('woff2'),
      url('../../assets/fonts/DINPro/DINPro-Medium.woff') format('woff');
    font-weight: 500;
    font-style: normal;
  }

  @font-face {
    font-family: 'DINPro';
    src:
      url('../../assets/fonts/DINPro/DINPro-Bold.woff2') format('woff2'),
      url('../../assets/fonts/DINPro/DINPro-Bold.woff') format('woff');
    font-weight: 700;
    font-style: normal;
  }

  @font-face {
    font-family: 'ITCGothicPro';
    src:
      url('../../assets/fonts/ITC/ITCAvantGardeGothicProDemi.woff2') format('woff2'),
      url('../../assets/fonts/ITC/ITCAvantGardeGothicProDemi.woff') format('woff');
    font-weight: 600;
    font-style: normal;
  }

  @font-face {
    font-family: 'ITCGothicPro';
    src:
      url('../../assets/fonts/ITC/ITCAvantGardeGothicBold.woff2') format('woff2'),
      url('../../assets/fonts/ITC/ITCAvantGardeGothicBold.woff') format('woff');
    font-weight: 700;
    font-style: normal;
  }

  * {
    box-sizing: border-box;
  }

  body {
    margin: 0;
    padding: 0;
    background-color: ${(props) =>
      props.mode === 'light' ? theme.colors.white : theme.colors.black};
    font-family: ${theme.fonts.mainFont};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: ${theme.colors.altovita};
  }
`

export default GlobalStyles
